import { maxPolicyEligibilityDays } from 'corso-types';
import { ChangeEvent } from 'react';
import { MultiSelectOption } from 'corso-admin-ui';

/**
 * Given an change `event` for an input, extract the value as a number, or `null` if the value is not a number.
 */
// TODO better name
export function getNullableNumberValue(event: ChangeEvent<HTMLInputElement>) {
  const { valueAsNumber } = event.target;
  return Number.isNaN(valueAsNumber) ? null : valueAsNumber;
}

export function handleLifetimeFieldValue(value?: number | null | string) {
  if (value === maxPolicyEligibilityDays) return Infinity;
  if (value === null) return null;
  return value as number;
}

// Bridge between numeric ids stored on a form (e.g. custom-field id arrays)
// and the string-keyed `MultiSelectOption[]` shape that `<MultiSelect>` expects.
// Falls back to the raw id when no option matches.
export const numberIdsToOptions = (
  ids: number[],
  options: MultiSelectOption[],
): MultiSelectOption[] =>
  ids.map((id) => ({
    label: options.find((o) => o.value === `${id}`)?.label ?? `${id}`,
    value: `${id}`,
  }));

export const optionsToNumberIds = (selections: MultiSelectOption[]) =>
  selections.map((s) => Number.parseInt(s.value, 10));
